export const getPeloponneseData = () => ({
  name: "Péloponnèse",
  country: "Grèce",
  description: "Le Péloponnèse est une péninsule historique de Grèce, produisant des vins rouges et blancs de qualité, notamment dans les appellations Nemea et Mantinia.",
  type: "region",
  mapAreas: [
    { region: "Péloponnèse", x: 52, y: 45, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "15,000 ha",
    production: "1,200,000 hl",
    wineries: "150+ domaines",
    villages: "25+ communes",
    exportPercentage: "15%"
  },
  characteristics: {
    climate: "Climat méditerranéen, étés chauds et secs",
    soil: "Sols calcaires, argileux, schisteux",
    viticulture: "Vendanges manuelles, élevage traditionnel"
  },
  wineStyles: {
    red: "Rouges fruités et épicés (Agiorgitiko)",
    white: "Blancs secs et aromatiques (Moschofilero)",
    dessert: "Vins doux naturels traditionnels"
  },
  history: "Le Péloponnèse produit du vin depuis l'Antiquité. La région de Nemea est célèbre pour ses vins rouges depuis l'époque mycénienne.",
  foodPairing: "Agneau rôti, fromages grecs, moussaka, poissons méditerranéens, olives",
  subregions: [
    { name: "Nemea", area: "3,500 ha", percentage: "23.3%", description: "Vins rouges Agiorgitiko" },
    { name: "Mantinia", area: "2,000 ha", percentage: "13.3%", description: "Vins blancs Moschofilero" },
    { name: "Patras", area: "1,500 ha", percentage: "10.0%", description: "Vins blancs et rouges" },
    { name: "Messinia", area: "1,200 ha", percentage: "8.0%", description: "Vins traditionnels" },
    { name: "Laconia", area: "800 ha", percentage: "5.3%", description: "Vins de montagne" }
  ],
  grapeVarieties: [
    { name: "Agiorgitiko", percentage: "30%", description: "Cépage rouge principal de Nemea" },
    { name: "Moschofilero", percentage: "20%", description: "Cépage blanc aromatique" },
    { name: "Roditis", percentage: "15%", description: "Cépage blanc polyvalent" },
    { name: "Mavrodaphne", percentage: "10%", description: "Cépage rouge pour vins doux" },
    { name: "Assyrtiko", percentage: "8%", description: "Cépage blanc de Santorin" },
    { name: "Autres", percentage: "17%", description: "Cépages locaux et internationaux" }
  ]
});
